document.addEventListener("DOMContentLoaded", function (event) {
    window.addEventListener("load", function (e) {
        gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

        const tlLigne = gsap.timeline();
        tlLigne.set(".hide-start", {
            autoAlpha: 1,
        })

        tlLigne.fromTo(".ligne", {
            drawSVG: "100% 100%"
        }, {
            drawSVG: "100%",
            duration: 2,
            ease: "none"
        })

        tlLigne.from("#mot1", {
            xPercent: -25,
            opacity: 0,
        }, "<")

        tlLigne.from("#mot2", {
            xPercent: -25,
            opacity: 0,
        }, "<+=0.5")

        tlLigne.from("#mot3", {
            xPercent: 25,
            opacity: 0,
        }, "<+=0.6")
    });
});